import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import { useTimeLeft } from "app/components/timers/hooks/useTimeLeft";
import { i18nFilter } from "app/filters/i18nFilter";
import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { BoldText, BoxContainer, Colon, Title } from "./StyledComponent";

interface ITimeCountingDiscountProps {
    discountEndDateFromSettings?: string;
    discountEndTime?: string;
}

export const TimeCountingDiscount = ({ discountEndDateFromSettings, discountEndTime }: ITimeCountingDiscountProps) => {
    const timeLeft = useTimeLeft({ discountEndDateFromSettings, discountEndTime });
    const translate = i18nFilter();

    const counterItems = Object.keys(timeLeft) as Array<keyof typeof timeLeft>;

    const counter = counterItems.map((time, index) => {
        const isLast = index === counterItems.length - 1;

        const timeLeftValue = timeLeft[time];

        return (
            <FlexRow key={`${time}-${timeLeftValue}`}>
                <BoxContainer>{timeLeftValue}</BoxContainer>
                {!isLast ? <Colon>:</Colon> : null}
            </FlexRow>
        );
    });

    return (
        <LeftFlexRow id="TimeCountingDiscount">
            <Title>
                <BoldText>{translate("pro.time.counting.discount.title.prefix")}</BoldText>
                {translate("pro.time.counting.discount.title.suffix")}
            </Title>
            {counter}
        </LeftFlexRow>
    );
};
